import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { useTranslation } from "@redotech/redo-i18n";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import TagFilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoConversionRpcClientContext } from "@redotech/redo-merchant-app-common/redo-conversion-rpc-client-provider";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const PricingTestItems = memo(function PricingTestItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const conversionRpcClient = useRequiredContext(
    RedoConversionRpcClientContext,
  );

  const hasPricingTestsLoad = useLoad(
    async (signal) => {
      const result = await conversionRpcClient.merchantHasPricingTests(
        {},
        { signal },
      );
      return result.hasPricingTests;
    },
    [conversionRpcClient],
  );

  if (hasPricingTestsLoad.pending || !hasPricingTestsLoad.value) {
    return null;
  }

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_PRICING_TESTS}
      feature={ConversionFeature.PRICING_TESTS}
      FilledIcon={TagFilledIcon}
      friendlyName={t("Pricing tests", {
        context: "checkout conversion navigation label",
      })}
      href={routes.getConversionSubRoute("pricing-tests")}
      id="pricing-tests"
      UnfilledIcon={TagIcon}
    />
  );
});
